import { FC, useRef } from 'react';

import { formatCost } from 'utils/clickme';
import { NON_BREAKING_SPACE } from 'utils/constants/common';

import { Text, useBreakpoint } from '@hh.ru/magritte-ui';
import { QuestionCircleOutlinedSize16 } from '@hh.ru/magritte-ui/icon';

import useOnOffState from 'hooks/common/useOnOffState';

import FormatMoney from 'components/FormatMoney';

import { TooltipCommon } from 'components/common/TooltipCommon/TooltipCommon';

import styles from 'components/common/BalanceCardContent/BalanceInfoRow/BalanceInfoRow.module.less';

interface BalanceInfoRow {
    label: string;
    tooltipText?: string;
    amount: number;
    amountDataQa?: string;
    isNegative?: boolean;
    hideCurrency?: boolean;
}

export const BalanceInfoRow: FC<BalanceInfoRow> = ({
    label,
    tooltipText,
    amount,
    amountDataQa,
    isNegative = false,
    hideCurrency = false,
}) => {
    const [isTooltipVisible, setIsTooltipVisibleOn, setIsTooltipVisibleOff] = useOnOffState(false);

    const hintRef = useRef(null);
    const { isMobile } = useBreakpoint();

    return (
        <>
            <div className={styles.wrapper}>
                <div className={styles.label}>
                    <Text typography="label-2-regular" style={isNegative ? 'negative' : 'secondary'}>
                        {label}
                    </Text>
                    {tooltipText && (
                        <QuestionCircleOutlinedSize16
                            ref={hintRef}
                            initialColor={isNegative ? 'negative' : 'secondary'}
                            onClick={setIsTooltipVisibleOn}
                            onMouseEnter={isMobile ? undefined : setIsTooltipVisibleOn}
                            onMouseLeave={isMobile ? undefined : setIsTooltipVisibleOff}
                        />
                    )}
                </div>
                <Text typography="label-2-regular" style={isNegative ? 'negative' : 'primary'} data-qa={amountDataQa}>
                    {hideCurrency ? (
                        formatCost(amount, NON_BREAKING_SPACE)
                    ) : (
                        <FormatMoney groupSeparator={NON_BREAKING_SPACE}>{amount}</FormatMoney>
                    )}
                </Text>
            </div>
            {tooltipText && (
                <TooltipCommon
                    activatorRef={hintRef}
                    tooltipContent={
                        <Text typography={isMobile ? 'label-1-regular' : 'paragraph-2-regular'}>{tooltipText}</Text>
                    }
                    bottomSheetTitle={label}
                    visible={isTooltipVisible}
                    onClose={setIsTooltipVisibleOff}
                />
            )}
        </>
    );
};
